import Layout from "@/components/feature/Layout";
import PageHero from "@/components/feature/PageHero";
import FAQAccordion from "@/components/feature/FAQAccordion";
import Button from "@/components/base/Button";
import CTASection from "@/components/feature/CTASection";
import { useSiteData } from "@/context/SiteDataContext";
import { useT } from "@/lib/useSiteText";

export default function PreguntasFrecuentes() {
  const { data, whatsappLink } = useSiteData();
  const t = useT();
  const otraDescripcion = t("faq.otra_descripcion");
  const faqs = data.faqs;
  const hero = data.pages["preguntas-frecuentes"];

  return (
    <Layout>
      <PageHero
        titulo={hero.hero_titulo}
        descripcion={hero.hero_descripcion}
        imagen={hero.hero_imagen_url}
        alt={hero.hero_imagen_alt}
      />

      <section className="bg-background-50">
        <div className="mx-auto max-w-3xl px-4 md:px-6 py-14 md:py-20">
          <FAQAccordion items={faqs} />

          <div className="mt-10 rounded-lg bg-background-100 p-7 text-center">
            <h2 className="font-heading font-semibold text-xl text-foreground-950">{t("faq.otra_titulo")}</h2>
            {otraDescripcion && <p className="mt-2 text-foreground-600">{otraDescripcion}</p>}
            <div className="mt-5 flex flex-col sm:flex-row items-center justify-center gap-3">
              <Button href={whatsappLink(t("wa.faq"))} variant="accent" icon="ri-whatsapp-line">
                {t("faq.boton_whatsapp")}
              </Button>
              <Button to="/contacto" variant="outline">
                {t("faq.boton_formulario")}
              </Button>
            </div>
          </div>
        </div>
      </section>

      <CTASection />
    </Layout>
  );
}